import { jsx as _jsx } from "react/jsx-runtime";
import { OptimizeImage } from '@telus-uds/components-web';
import { RICH_TEXT_TYPES } from '../../types';
var BLOCKS = RICH_TEXT_TYPES.BLOCKS;
export var buildEmbeddedAsset = function () {
    var _a;
    return _a = {},
        _a[BLOCKS.EMBEDDED_ASSET] = function (node) {
            var _a, _b, _c, _d;
            var fields = (_b = (_a = node === null || node === void 0 ? void 0 : node.data) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.fields;
            var contentType = (_c = fields === null || fields === void 0 ? void 0 : fields.file) === null || _c === void 0 ? void 0 : _c.contentType;
            var props = { alt: fields === null || fields === void 0 ? void 0 : fields.description };
            switch (contentType) {
                case 'image/png':
                case 'image/jpeg':
                case 'image/gif': {
                    return _jsx(OptimizeImage, { contentfulAssetUrl: (_d = fields === null || fields === void 0 ? void 0 : fields.file) === null || _d === void 0 ? void 0 : _d.url, alt: props.alt });
                }
                default: {
                    return null;
                }
            }
        },
        _a;
};
